import React from "react";
import { Container, Text, withStyles } from "../../common";

const AvailableCredit = () => (
  <div className="w-full h-full">
    <Container className="w-full flex-1 h-full justify-center">
      <div className="flex flex-col items-center text-center">
        <Text title>Spending Power</Text>
        <Text className="text-2xl md:text-3xl mt-2" weight="light">
          $250-$10,000
        </Text>
      </div>
    </Container>
  </div>
);

export default withStyles(AvailableCredit);
